import React, { Component } from "react";
import { Link } from "react-router-dom";
import styles from "../../thema/style";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import FloatingWhatsApp from "../../components/FloatingWhatsApp";
class Footer extends Component {
  render() {
    return (
      <React.Fragment>
        {this.props.setting.setting.wpTitle !== "" && (
          <FloatingWhatsApp
            title={this.props.setting.setting.wpTitle}
            content={this.props.setting.setting.wpContent}
            phoneNumber={this.props.setting.setting.wpPhone}
          />
        )}
        <footer className={"row"}>
          <div className={`${styles.mainFooter} col-md-12`}>
            <div className={"container"}>
              <div className={"row"}>
                <div className={"col-md-4"}>
                  <h3>Hakkımızda</h3>
                  <p>
                    {this.props.setting.setting &&
                      this.props.setting.setting.footer_info}
                  </p>
                </div>
                <div className={"col-md-2"}>
                  <h3>Bilgiler</h3>
                  <ul>
                    {this.props.page.page &&
                      this.props.page.page.map(
                        (page, i) =>
                          page.location === "bottom_menu" && (
                            <li key={i}>
                              <Link
                                to={{
                                  pathname: `/p/${page.slug}`,
                                  state: { page },
                                }}
                              >
                                {page.menu_title}
                              </Link>
                            </li>
                          )
                      )}
                  </ul>
                </div>
                <div className={"col-md-3"}>
                  <h3>Sosyal Hesaplar</h3>
                  <ul>
                    <li>
                      <a
                        target="_blank"
                        href={
                          this.props.setting.setting &&
                          this.props.setting.setting.facebook
                        }
                      >
                        Facebook
                      </a>
                    </li>
                    <li>
                      <a
                        target="_blank"
                        href={
                          this.props.setting.setting &&
                          this.props.setting.setting.instagram
                        }
                      >
                        İnstagram
                      </a>
                    </li>
                  </ul>
                </div>
                <div className={"col-md-3"}>
                  <h3>İletişim</h3>
                  <ul className={styles.footerContact}>
                    <li>
                      <span>
                        <FontAwesomeIcon icon={["fa", "envelope"]} />
                      </span>{" "}
                      {this.props.setting.setting &&
                        this.props.setting.setting.footer_mail}
                    </li>
                    <li>
                      <span>
                        <FontAwesomeIcon icon={["fa", "phone"]} />
                      </span>{" "}
                      {this.props.setting.setting &&
                        this.props.setting.setting.footer_phone}
                    </li>
                    <li>
                      <span>
                        <FontAwesomeIcon icon={["fa", "map-marker-alt"]} />
                      </span>{" "}
                      {this.props.setting.setting &&
                        this.props.setting.setting.footer_address}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className={`${styles.bottomFooter} col-md-12`}>
            <div className={"container"}>
              <div className={"row"}>
                <div className={"col-md-6 text-left"}>
                  {this.props.setting.setting &&
                    this.props.setting.setting.copyright}
                </div>
                <div className={"col-md-6 text-right"}>
                  Bu Bir{" "}
                  <a
                    href="http://swbilisim.com"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    SW Bilişim
                  </a>{" "}
                  Ürünüdür.
                </div>
              </div>
            </div>
          </div>
        </footer>
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({ setting, page }) => {
  return { setting, page };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Footer);



// WEBPACK FOOTER //
// ./src/components/shared/Footer.js